// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_lL9","label":"styles_label__3PSSo"};